import StatProposedTrades from '@static/images/stat_proposed_trades.svg';
import StatSuccessfulTrades from '@static/images/stat_successful_trades.svg';
import StatResourcesUsed from '@static/images/stat_resources_used.svg';
import StatResourceIncomeBlocked from '@static/images/stat_resource_income_blocked.svg';
import StatDevCardBought from '@static/images/stat_dev_card_bought.svg';
import StatDevCardUsed from '@static/images/stat_dev_card_used.svg';
import StatResGain from '@static/images/stat_res_gain.svg';
import StatResLoss from '@static/images/stat_res_loss.svg';
import StatResScore from '@static/images/stat_res_score.svg';
import StatRollingIncome from '@static/images/stat_rolling_income.svg';
import StatRobbingIncome from '@static/images/stat_robbing_income.svg';
import StatDevCardIncome from '@static/images/stat_dev_card_income.svg';
import StatTradeIncome from '@static/images/stat_trade_income.svg';
import StatRollingLoss from '@static/images/stat_rolling_loss.svg';
import StatRobbingLoss from '@static/images/stat_robbing_loss.svg';
import StatDevCardLoss from '@static/images/stat_dev_card_loss.svg';
import StatTradeLoss from '@static/images/stat_trade_loss.svg';
import StatGoldIncome from '@static/images/stat_gold_income.svg';
import StatDevCardBoughtCk from '@static/images/stat_dev_card_bought_ck.svg';
import StatDevCardUsedCk from '@static/images/stat_dev_card_used_ck.svg';
import StatDevCardIncomeCk from '@static/images/stat_dev_card_income_ck.svg';
import StatDevCardLossCk from '@static/images/stat_dev_card_loss_ck.svg';
import StoreItemCitiesAndKnights4P from '@static/images/store/store_item_cities_and_knights.png';
import StoreItemExpansionClassic78P from '@static/images/store/store_item_78player.png';
import MapSS3FogIslands4PPreview from '@static/images/map_ss3_4p_preview.png';
import GifRemoveAdsHexDesert from '@static/images/gif_remove_ads_hexedshape_desert.gif';
import GifRemoveAdsBoxDesert from '@static/images/gif_remove_ads_boxedshape_desert.gif';
import GifRemoveAdsHexGold from '@static/images/gif_remove_ads_hexedshape_gold.gif';
import GifRemoveAdsBoxGold from '@static/images/gif_remove_ads_boxedshape_gold.gif';
import RushEndGameAd4Player from '@static/images/rush_end_game_ad_4_player.png';
import RushEndGameAdNoTurns from '@static/images/rush_end_game_ad_no_turns.png';
import RushEndGameAdSpeed from '@static/images/rush_end_game_ad_speed.png';
export const ACTIVITY_IMAGE_PATH = {
    proposedTrades: StatProposedTrades,
    successfulTrades: StatSuccessfulTrades,
    resourcesUsed: StatResourcesUsed,
    resourceIncomeBlocked: StatResourceIncomeBlocked,
    devCardsBought: StatDevCardBought,
    devCardsUsed: StatDevCardUsed
};
export const ACTIVITY_IMAGE_PATH_CK = {
    ...ACTIVITY_IMAGE_PATH,
    devCardsBought: StatDevCardBoughtCk,
    devCardsUsed: StatDevCardUsedCk
};
export const ACTIVITY_TRANSLATION = {
    proposedTrades: {
        title: {
            key: 'strings:game.endGame.activity.proposedTrades'
        }
    },
    successfulTrades: {
        title: {
            key: 'strings:game.endGame.activity.successfulTrades'
        }
    },
    resourcesUsed: {
        title: {
            key: 'strings:game.endGame.activity.resourcesUsed'
        }
    },
    resourceIncomeBlocked: {
        title: {
            key: 'strings:game.endGame.activity.resourceIncomeBlocked'
        }
    },
    devCardsBought: {
        title: {
            key: 'strings:game.endGame.activity.devCardsBought'
        }
    },
    devCardsUsed: {
        title: {
            key: 'strings:game.endGame.activity.devCardsUsed'
        }
    }
};
export const RESOURCE_ACTIVITY_IMAGE_PATH = {
    totalResourceIncome: StatResGain,
    totalResourceLoss: StatResLoss,
    totalResourceScore: StatResScore,
    rollingIncome: StatRollingIncome,
    robbingIncome: StatRobbingIncome,
    devCardIncome: StatDevCardIncome,
    tradeIncome: StatTradeIncome,
    rollingLoss: StatRollingLoss,
    robbingLoss: StatRobbingLoss,
    devCardLoss: StatDevCardLoss,
    tradeLoss: StatTradeLoss,
    goldIncome: StatGoldIncome
};
export const RESOURCE_ACTIVITY_IMAGE_PATH_CK = {
    ...RESOURCE_ACTIVITY_IMAGE_PATH,
    devCardIncome: StatDevCardIncomeCk,
    devCardLoss: StatDevCardLossCk
};
export const RESOURCE_ACTIVITY_TRANSLATION = {
    totalResourceIncome: {
        title: {
            key: 'strings:game.endGame.resource.totalResourceIncome'
        }
    },
    totalResourceLoss: {
        title: {
            key: 'strings:game.endGame.resource.totalResourceLoss'
        }
    },
    totalResourceScore: {
        title: {
            key: 'strings:game.endGame.resource.totalResourceScore'
        }
    },
    rollingIncome: {
        title: {
            key: 'strings:game.endGame.resource.rollingIncome'
        }
    },
    robbingIncome: {
        title: {
            key: 'strings:game.endGame.resource.robbingIncome'
        }
    },
    devCardIncome: {
        title: {
            key: 'strings:game.endGame.resource.devCardIncome'
        }
    },
    tradeIncome: {
        title: {
            key: 'strings:game.endGame.resource.tradeIncome'
        }
    },
    rollingLoss: {
        title: {
            key: 'strings:game.endGame.resource.rollingLoss'
        }
    },
    robbingLoss: {
        title: {
            key: 'strings:game.endGame.resource.robbingLoss'
        }
    },
    devCardLoss: {
        title: {
            key: 'strings:game.endGame.resource.devCardLoss'
        }
    },
    tradeLoss: {
        title: {
            key: 'strings:game.endGame.resource.tradeLoss'
        }
    },
    goldIncome: {
        title: {
            key: 'strings:game.endGame.resource.goldIncome'
        }
    }
};
export const AD_BOX_CONTENT = [
    {
        title: {
            key: 'strings:game.gameEndItem.defeatBarbarians'
        },
        image: StoreItemCitiesAndKnights4P,
        adSource: 'endGameStorePromo',
        variant: 'citiesAndKnights'
    },
    {
        title: {
            key: 'strings:game.gameEndItem.useSpecialBuild'
        },
        image: StoreItemExpansionClassic78P,
        adSource: 'endGameStorePromo',
        variant: 'expansion78p'
    },
    {
        title: {
            key: 'strings:game.gameEndItem.discoverRandomHexes'
        },
        image: MapSS3FogIslands4PPreview,
        adSource: 'endGameStorePromo',
        variant: 'fogIslands'
    },
    {
        title: {
            key: 'strings:colonistCommon.utils.emptyString'
        },
        image: GifRemoveAdsHexDesert,
        adSource: 'endGameMemberGif',
        variant: 'removeAdsHexDesert'
    },
    {
        title: {
            key: 'strings:colonistCommon.utils.emptyString'
        },
        image: GifRemoveAdsBoxDesert,
        adSource: 'endGameMemberGif',
        variant: 'removeAdsBoxDesert'
    },
    {
        title: {
            key: 'strings:colonistCommon.utils.emptyString'
        },
        image: GifRemoveAdsHexGold,
        adSource: 'endGameMemberGif',
        variant: 'removeAdsHexGold'
    },
    {
        title: {
            key: 'strings:colonistCommon.utils.emptyString'
        },
        image: GifRemoveAdsBoxGold,
        adSource: 'endGameMemberGif',
        variant: 'removeAdsBoxGold'
    },
    {
        title: {
            key: 'strings:colonistCommon.utils.emptyString'
        },
        image: RushEndGameAd4Player,
        adSource: 'endGame',
        variant: '4player'
    },
    {
        title: {
            key: 'strings:colonistCommon.utils.emptyString'
        },
        image: RushEndGameAdNoTurns,
        adSource: 'endGame',
        variant: 'noTurns'
    },
    {
        title: {
            key: 'strings:colonistCommon.utils.emptyString'
        },
        image: RushEndGameAdSpeed,
        adSource: 'endGame',
        variant: 'speed'
    }
];
export const FADE_IN_ANIMATION_DELAYS = {
    transitionDuration: 1000,
    ads: 2000,
    logo: 1000,
    topLeftButtons: 2000,
    content: 3000,
    contentRankedGame: 0,
    footerRankedGame: 0,
    footer: 4000
};
